exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edi-social-buttons .buttons-rs-panel .bg-comments--in-paywall[data-v-22ddf8f0]{position:relative}.edi-modal[data-v-22ddf8f0]{width:300px;top:-15px;right:0;transform:translateY(-100%)}@media only screen and (min-width:768px){.edi-modal[data-v-22ddf8f0]{width:330px;right:unset;left:26px}}.edi-modal[data-v-22ddf8f0]:after{right:12px;bottom:-6px}@media only screen and (min-width:768px){.edi-modal[data-v-22ddf8f0]:after{right:auto;left:26px}}", ""]);

// exports
